var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtB5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6987 51.748C32.5613 53.6666 35.1491 57.5921 38.5994 57.9463C42.9124 58.3891 63.1833 57.9463 64.9084 57.9463C66.2886 57.9463 68.0713 56.7657 68.7901 56.1754",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7892 73.4915C96.0076 73.4915 99.4865 70.4674 99.4865 67.4433C99.4865 64.4193 99.0517 59.2351 90.7892 57.0751C82.5268 54.9151 80.7874 55.3471 70.3506 48.4349C59.9139 41.5228 52.9561 43.2507 44.2588 42.8187C35.5615 42.3867 26.8642 48.0029 24.255 50.5949C22.1677 52.6686 19.0366 53.475 17.732 53.619C15.9926 53.619 12.5137 55.0015 12.5137 60.5312C12.5137 66.0609 15.4128 70.0354 16.8623 71.3314",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6353 68.0746C25.1049 66.2258 29.0861 63.0828 33.2543 65.3014C38.4646 68.0746 38.8654 73.6208 37.2622 76.394C35.6591 79.1671 29.2464 81.5441 25.6393 78.3748C22.7536 75.8393 22.5665 72.0361 22.8337 70.4514",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6406 65.4448C73.132 65.5996 71.3393 70.0787 71.0065 72.2989L71.4787 74.6364C72.0147 76.0678 73.9862 79.1094 77.5851 79.8251C82.0837 80.7197 86.2541 75.7155 86.2558 72.6709C86.2575 69.6263 83.2764 65.2514 77.6406 65.4448Z",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 71.5557C59.526 71.5557 47.0401 71.5557 43.5557 71.5557",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7211 24.8889L50.8838 31.284H57.2788L53.4417 37.679",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtB5);
export default __webpack_public_path__ + "static/media/vt_b5.31e84f6fe72626c7d101613c46f24d3a.svg";
export { ForwardRef as ReactComponent };